import * as React from 'react';

import type { EventProcedureStepAPIType } from 'security-app/hooks/api/eventProceduresAPI.types';
import SecurityRoutes from 'security-app/routing/Routes';

import StepActionButton from './StepActionButton';
import StepGoToDashboard from './StepGoToDashboard';
import StepPerformSearch from './StepPerformSearch';
import StepSendNotification from './StepSendNotification';

type Props = {
  eventId?: string;
  step: EventProcedureStepAPIType;
};

const getActionUrl = (stepId: string, eventId?: string): string => {
  const stepParam = `stepId=${stepId}`;
  const eventParam = eventId ? `&eventId=${eventId}` : '';
  const params = stepParam + eventParam;

  return `${SecurityRoutes.SECURITY_EVENTS.EVENT_PROCEDURES.executeAction()}?${params}`;
};

function StepActionsButton({ step, eventId = undefined }: Props) {
  const actionUrl = React.useMemo(() => getActionUrl(step.id, eventId), [step, eventId]);

  switch (step?.action?.config?.type) {
    case 'go_to_dashboard':
      return <StepGoToDashboard actionUrl={actionUrl} config={step?.action?.config} />;
    case 'execute_notification':
      return <StepSendNotification step={step} eventId={eventId} />;
    case 'perform_search':
      return <StepPerformSearch actionUrl={actionUrl} config={step?.action?.config} />;
    case 'link':
      return <StepActionButton title="Go to Link" to={actionUrl} />;
    default:
      return null;
  }
}

export default StepActionsButton;
